import { useTranslation } from "react-i18next";
import { Box, Card, CardContent, Container, Grid2 as Grid, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faKaaba, faAngleDoubleRight } from "@fortawesome/free-solid-svg-icons";


const IntroContent04 = () => {
    const { t } = useTranslation();

    return (
        <Container className="info-container">
            <Box className="info-header-expanded">
                <h1 className="info-header-title">
                    {t('bwob.task2.section1.title')}
                </h1>
            </Box>

            <Container className="info-content">

                <div className="info-highlight">
                    <strong>
                        <FontAwesomeIcon icon={faKaaba} size="lg" style={{ paddingRight: '10px' }}/> 
                        {t('bwob.task2.section1.item')}
                        <FontAwesomeIcon icon={faAngleDoubleRight} size="lg" style={{ margin: '0', marginLeft: '20px', padding: '0px'}}/><FontAwesomeIcon icon={faAngleDoubleRight} size="lg" style={{ margin: '0', marginLeft: '-5px', padding: '0px' }}/> 
                    </strong>
                </div>

                <Grid container layout={'row'} spacing={0} columns={7} className="info-content-box" sx={{ padding: "10px 20px", justifyContent: "center", alignItems: "flex-start", }}>

                    <Grid className="info-left-column" size={{ xs: 7, sm: 7, md: 3.3, }} sx={{ height: '100%'}}>
                        <Grid container spacing={0} sx={{ padding: "0px", margin: "0px", height: "100%" }} className="info-item-arrow-right">

                            <Grid size={2} sx={{ padding: "0px", margin: "0px" }}>
                                <Typography component="div" variant="div" className="info-item-ai" />
                            </Grid>
                            <Grid size={10} sx={{ padding: "0px", margin: "0px" }} className="info-step-section">
                                <h2>{t('bwob.task2.section1.subject1')}</h2>
                            </Grid>

                        </Grid>

                        <Grid container spacing={1} sx={{ padding: "0px", margin: "0px", marginTop: "5px", height: "100%", justifyContent: "center", alignItems: "center", }}>

                            <Grid item variant="body1" size={2} sx={{ padding: "10px", margin: "0px", height: "100%", minHeight: '144px', justifyContent: "center", alignItems: "center" }} className="info-left-column-group">
                                <Typography component="div" variant="body1">
                                    {t('bwob.task2.section1.subject1-item1')}
                                </Typography>
                            </Grid>
                            <Grid size={10} sx={{ padding: "0px", margin: "0px" }}>
                                <div className="info-step-section coffee-busan-background01">
                                    <div className="info-step-box"><span>01</span> {t('bwob.words.w070')}</div>
                                    <div className="info-step-box"><span>02</span> {t('bwob.words.w071')}</div>
                                </div>
                            </Grid>

                        </Grid>

                        <Grid container spacing={1} sx={{ padding: "0px", margin: "0px", marginTop: "15px", height: "100%", justifyContent: "center", alignItems: "center" }}>

                            <Grid variant="body1" size={2} sx={{ padding: "10px", margin: "0px", height: "100%", minHeight: '292px' }} className="info-left-column-group">
                                <Typography component="div">
                                    {t('bwob.task2.section1.subject1-item2')}
                                </Typography>
                            </Grid>
                            <Grid size={10} sx={{ padding: "0px", margin: "0px" }}>
                                <div className="info-step-section coffee-busan-background01">
                                    <div className="info-step-box"><span>03</span> {t('bwob.words.w072')}</div>
                                    <div className="info-step-box"><span>04</span> {t('bwob.words.w073')}</div>
                                    <div className="info-step-box"><span>05</span> {t('bwob.words.w074')}<br /> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ({t('bwob.words.w075')})</div>
                                    <div className="info-step-box"><span>06</span> {t('bwob.words.w076')}</div>
                                </div>
                            </Grid>

                        </Grid>

                        <Grid container spacing={1} sx={{ padding: "0px", margin: "0px", marginTop: "15px", height: "100%", justifyContent: "center", alignItems: "center" }}>

                            <Grid variant="body1" size={2} sx={{ padding: "10px", margin: "0px", height: "100%", minHeight: "82px" }} className="info-left-column-group">
                                <Typography component="div">
                                    {t('bwob.task2.section1.subject1-item3')}
                                </Typography>
                            </Grid>
                            <Grid size={10} sx={{ padding: "0px", margin: "0px" }}>
                                <div className="info-step-section coffee-busan-background01">
                                    <div className="info-step-box"><span>07</span> {t('bwob.words.w077')}</div>
                                </div>
                            </Grid>

                        </Grid>
                    </Grid>

                    <Grid item className="info-left-column" size={{ xs: 7, sm: 7, md: 0.4, }} sx={{ height: '100%', justifyContent: "center", alignItems: "center", display: { xs: 'none', sm: 'none',  md: 'flex' } }}>
                        <div className="info-plus-box">+</div>
                    </Grid>

                    <Grid className="info-right-column" size={{ xs: 7, sm: 7, md: 3.3, }} sx={{ height: '100%'}}>
                        <Grid container spacing={0} sx={{ padding: "0px", margin: "0px", height: "100%" }} className="info-item-arrow-left">
                            <Grid size={10} sx={{ padding: "0px", margin: "0px" }} className="info-data-section">
                                <h2 style={{ paddingLeft: "50px" }}>{t('bwob.task2.section1.subject2')}</h2>
                            </Grid>
                            <Grid size={2} sx={{ padding: "0px", margin: "0px" }}>
                                <Typography component="div" variant="div" className="info-item-chain" />
                            </Grid>
                        </Grid>
                        <div className="info-data-section coffee-busan-background01">
                            <div className="info-data-chain">

                                <Card className="info-data-item" sx={{ padding: "0px", margin: "0px", boxShadow: "none", backgroundImage: "none" }}>
                                    <CardContent sx={{ padding: "0px 10px", margin: "2px", "&:last-child": { paddingBottom: "8px" } }}>
                                        <Typography gutterBottom variant="h6" component="div" sx={{ mt: 2, fontWeight: '450', marginTop: "2px" }} className="info-data-item-title">
                                            <strong>{t('bwob.words.w017')}</strong>
                                        </Typography>
                                        <Typography component="div" variant="body1">
                                            <span className="info-label-bubble">{t('bwob.words.w017')}</span>
                                            <span className="info-label-bubble">{t('bwob.words.w083')}</span>
                                            <span className="info-label-bubble">{t('bwob.words.w084')}</span>
                                            <span className="info-label-bubble">{t('bwob.words.w085')}</span>
                                            <span className="info-label-bubble">{t('bwob.words.w086')}</span>
                                        </Typography>  
                                    </CardContent>
                                </Card>

                                <Card className="info-data-item" sx={{ padding: "0px", margin: "0px", boxShadow: "none" }}>
                                    <CardContent sx={{ padding: "0px 10px", margin: "0px", "&:last-child": { paddingBottom: "8px" } }}>
                                        <Typography gutterBottom variant="h6" component="div" sx={{ mt: 2, fontWeight: '450', marginTop: "2px" }} className="info-data-item-title">
                                            <strong>{t('bwob.words.w078')}</strong>
                                        </Typography>
                                        <Typography variant="body1">
                                            <span className="info-label-bubble">{t('bwob.words.w087')}</span>
                                            <span className="info-label-bubble">{t('bwob.words.w088')}</span>
                                            <span className="info-label-bubble">{t('bwob.words.w089')}</span>
                                        </Typography>  
                                    </CardContent>
                                </Card>

                                <Card className="info-data-item" sx={{ padding: "0px", margin: "0px", boxShadow: "none" }}>
                                    <CardContent sx={{ padding: "0px 10px", margin: "0px", "&:last-child": { paddingBottom: "8px" } }}>
                                        <Typography gutterBottom variant="h6" component="div" sx={{ mt: 2, fontWeight: '450', marginTop: "2px" }} className="info-data-item-title">
                                            <strong>{t('bwob.words.w079')}</strong>
                                        </Typography>
                                        <Typography variant="body1">
                                            <span className="info-label-bubble">{t('bwob.words.w090')}</span>
                                            <span className="info-label-bubble">{t('bwob.words.w091')}</span>
                                            <span className="info-label-bubble">{t('bwob.words.w092')}</span>
                                            <span className="info-label-bubble">{t('bwob.words.w093')}</span>
                                        </Typography>  
                                    </CardContent>
                                </Card>

                                <Card className="info-data-item" sx={{ padding: "0px", margin: "0px", boxShadow: "none" }}>
                                    <CardContent sx={{ padding: "0px 10px", margin: "0px", "&:last-child": { paddingBottom: "8px" } }}>
                                        <Typography gutterBottom variant="h6" component="div" sx={{ mt: 2, fontWeight: '450', marginTop: "2px" }} className="info-data-item-title">
                                            <strong>{t('bwob.words.w080')}</strong>
                                        </Typography>
                                        <Typography variant="body1">
                                            <span className="info-label-bubble">{t('bwob.words.w094')}</span>
                                            <span className="info-label-bubble">{t('bwob.words.w095')}</span>
                                            <span className="info-label-bubble">{t('bwob.words.w096')}</span>
                                            <span className="info-label-bubble">{t('bwob.words.w097')}</span>
                                            <span className="info-label-bubble">{t('bwob.words.w098')}</span>
                                        </Typography>  
                                    </CardContent>
                                </Card>

                                <Card className="info-data-item" sx={{ padding: "0px", margin: "0px", boxShadow: "none" }}>
                                    <CardContent sx={{ padding: "0px 10px", margin: "0px", "&:last-child": { paddingBottom: "8px" } }}>
                                        <Typography gutterBottom variant="h6" component="div" sx={{ mt: 2, fontWeight: '450', marginTop: "2px" }} className="info-data-item-title">
                                            <strong>{t('bwob.words.w081')}</strong>
                                        </Typography>
                                        <Typography variant="body1">
                                            <span className="info-label-bubble">{t('bwob.words.w099')}</span>
                                            <span className="info-label-bubble">{t('bwob.words.w100')}</span>
                                        </Typography>  
                                    </CardContent>
                                </Card>

                                <Card className="info-data-item" sx={{ padding: "0px", margin: "0px", boxShadow: "none" }}>
                                    <CardContent sx={{ padding: "0px 10px", margin: "0px", "&:last-child": { paddingBottom: "8px" } }}>
                                        <Typography gutterBottom variant="h6" component="div" sx={{ mt: 2, fontWeight: '450', marginTop: "2px" }} className="info-data-item-title">
                                            <strong>{t('bwob.words.w082')}</strong>
                                        </Typography>
                                        <Typography variant="body1">
                                            <span className="info-label-bubble">{t('bwob.words.w101')}</span>
                                            <span className="info-label-bubble">{t('bwob.words.w102')}</span>
                                            <span className="info-label-bubble">{t('bwob.words.w103')}</span>
                                        </Typography>  
                                    </CardContent>
                                </Card>
                                
                            </div>
                        </div>
                    </Grid>

                </Grid>
            </Container>
        </Container>
    );
};

export default IntroContent04;